import { motion } from 'framer-motion';
import React, { FC } from 'react';
import styled from 'styled-components';

const Svg = styled(motion.svg)`
    opacity: 0.2;
    path {
        stroke: ${({ theme }) => theme.colors.blue.medium};
        stroke-width: 2px;
        stroke-linejoin: round;
        stroke-linecap: round;
    }
`;

const World: FC = (props) => (
    <Svg
        viewBox="0 0 293 293"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path d="M288.931 146.5C288.931 174.67 280.578 202.208 264.928 225.63C249.277 249.053 227.033 267.309 201.007 278.089C174.981 288.869 146.343 291.69 118.714 286.194C91.0853 280.698 65.7066 267.133 45.7873 247.214C25.868 227.294 12.3029 201.916 6.80714 174.287C1.31143 146.658 4.13203 118.02 14.9123 91.9943C25.6925 65.9685 43.9482 43.7239 67.3707 28.0735C90.7933 12.423 118.331 4.06958 146.501 4.06958C184.276 4.06958 220.504 19.0756 247.215 45.7865C273.925 72.4974 288.931 108.725 288.931 146.5Z" />
        <path d="M146.5 288.931C188.123 288.931 221.866 225.162 221.866 146.5C221.866 67.8379 188.123 4.06958 146.5 4.06958C104.876 4.06958 71.1338 67.8379 71.1338 146.5C71.1338 225.162 104.876 288.931 146.5 288.931Z" />
        <path d="M254.096 53.0656C227.889 68.855 189.799 78.6217 147.151 78.6217C104.503 78.6217 65.1109 68.3667 39.0664 52.2517" />
        <path d="M39.0664 239.934C65.1109 223.819 103.852 213.564 147.151 213.564C190.45 213.564 228.377 223.494 254.421 239.283" />
        <path d="M146.5 4.06958V288.931" />
        <path d="M4.07031 146.5H288.931" />
    </Svg>
);

export default World;
